import React from "react";
import PublicNotifications from "components/common/PublicNotifications";
import GlobalAppNotifications from "./GlobalAppNotifications";
const WithGlobalNotifications = ({ children }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(GlobalAppNotifications, null), /* @__PURE__ */ React.createElement(PublicNotifications, null), children);
export default WithGlobalNotifications;
